import {create} from 'zustand'

interface LoginState {
  loggedInBy: string
  setLoggedInBy: (value: string) => void
}

export const useLoginStore = create<LoginState>()((set) => ({
  loggedInBy: '',

  setLoggedInBy: (value: string) => {
    set({loggedInBy: value})
  },
}))

// Export hook with same name as before for easier migration
export const useLoginCriteria = () => useLoginStore()
